import { useEffect } from "react";
import InputWrapper from "../InputWrapper/InputWrapper";

export default function TextInput({
  id,
  label,
  defaultValue,
  register,
  formState,
  wrapperProps,
  useFormMethods,
  attributes,
}) {
  const { errors } = formState;

  // Depend on setValue itself, not the useFormMethods object: FormContainer
  // rebuilds that object every render, so depending on it re-fires this effect
  // on every render, and setValue triggers the next one.
  const setValue = useFormMethods?.setValue;

  useEffect(() => {
    if (defaultValue && setValue) {
      setValue(id, defaultValue);
    }
  }, [defaultValue, id, setValue]);

  if (!id || !label || !register || !formState) {
    return <p>Could not load this field</p>;
  }

  return (
    <InputWrapper label={label} id={id} formState={formState} {...wrapperProps}>
      <input
        type="text"
        id={id}
        name={id}
        className={`textInput`}
        defaultValue={defaultValue ?? null}
        {...attributes}
        {...register(id)}
        aria-invalid={errors[id] ? "true" : "false"}
      />
    </InputWrapper>
  );
}
